// EmployeeRepository.ts

import { API_ENDPOINTS } from "../../../../Api/apiEndPoints";
import axiosInstance from "../../../../Api/axiosInstance";

export const getSubscriberType = async (params?: Record<string, any>) => {
    const response = await axiosInstance.get(
        API_ENDPOINTS.Subscriber.GET_SUBSCRIBER_TYPE,
        { params: params }
    );
    console.log(
        "🚀 ~ file: SubscriberRepository.ts ~ line 9 ~ getSubscriberType ~ response",
        response?.data?.data?.data
    );
    let dt = response?.data?.data?.data
    if (dt && dt?.length > 0) {
        let formattedData = dt?.reduce((arr: any, item: any) => {
            arr.push({ id: item?.SubscriberTypeId, label: item?.TypeName })
            return arr;
        }, [])
        return { response: response?.data, data: formattedData }
    }

    return { response: response?.data, data: [] };
};
export const getOutletType = async (params?: Record<string, any>) => {
    const response = await axiosInstance.get(
        API_ENDPOINTS.Subscriber.GET_OUTLET_TYPE_LIST
    );
    console.log(
        "🚀 ~ file: SubscriberRepository.ts ~ line 9 ~ getOutletType ~ response",
        response?.data?.data
    );
    let dt = response?.data?.data
    if (dt && dt?.length > 0) {
        let formattedData = response?.data?.data?.reduce((arr: any, item: any) => {
            arr.push({ id: item?.OutlettypeId, label: item?.OutlettypeName })
            return arr;
        }, [])
        return { response, data: formattedData }
    }

    return { response, data: [] }
};
// Add Subscriber Type 
export const addSubscriberTypes = async (body: any) => {
    return axiosInstance.post(API_ENDPOINTS.Subscriber.ADD_SUBSCRIBER_TYPE, body);
};

//Update Subscriber Type
export const updateSubscriberType = async (id: number, body: any) => {
    return axiosInstance.put(`${API_ENDPOINTS.Subscriber.UPDATE_SUBSCRIBER_TYPE}/${id}`, body);
};

export const getSubscriberFields = async (typeId: number | any, params?: Record<string, any>) => {
    const response = await axiosInstance.get(
        `${API_ENDPOINTS.Subscriber.GET_SUBSCRIBER_FIELDS}/${typeId}`,
        { params: params }
    );
    console.log(
        "🚀 ~ file: SubscriberRepository.ts ~ line 9 ~ getSubscriberFields ~ response",
        response
    );
    return response?.data;
};


export const addSubscriberFields = async (body: any) => {
    return axiosInstance.post(API_ENDPOINTS.Subscriber.ADD_SUBSCRIBER_FIELDS, body);
};
export const updateSubscriberFields = async (id: number, body: any) => {
    return axiosInstance.put(`${API_ENDPOINTS.Subscriber.UPDATE_SUBSCRIBER_FIELDS}/${id}`, body);
};

export const getSurveyQuestionTypes = async (params?: Record<string, any>) => {
    const response = await axiosInstance.get(
        API_ENDPOINTS.Subscriber.GET_SURVEY_QUESTION_TYPES
    );
    console.log(
        "🚀 ~ file: SubscriberRepository.ts ~ line 9 ~ getSurveyQuestionTypes ~ response",
        response?.data
    );

    let dt = response?.data?.data
    if (dt && Object.keys(dt || {})?.length > 0) {
        let formattedData = Object.keys(dt || {})?.reduce((arr: any, item: any) => {
            arr.push({ id: `${item}`, label: `${item}` })
            return arr;
        }, [])
        return { response, data: formattedData }
    }

    return { response, data: [] }
};
export const getStatusOptionsData = async (params?: Record<string, any>) => {
    const response = await axiosInstance.get(
        API_ENDPOINTS.Subscriber.GET_STATUS_OPTIONS
    );
    console.log(
        "🚀 ~ file: SubscriberRepository.ts ~ line 9 ~ getStatusOptionsData ~ response",
        response?.data
    );

    let dt = response?.data?.data?.Status
    if (dt && Object.keys(dt || {})?.length > 0) {
        let formattedData = Object.keys(dt || {})?.reduce((arr: any, item: any) => {
            arr.push({ id: `${item}`, label: dt[item] })
            return arr;
        }, [])
        return { response, data: formattedData }
    }

    return { response, data: [] }
};